// react imports
import { useState, useEffect } from "react";
import { CalculatorResult } from "features/auth/types";

// common imports
import CrossIcon from "common/svg/CrossIcon";

// styled-components imports
import Container from "./styled-components/Container";
import CloseActionContainer from "./styled-components/CloseActionContainer";
import CloseButton from "./styled-components/CloseButton";
import Dialog from "./styled-components/Dialog";
import Title from "./styled-components/Title";
import ArrowLeft from "../../common/svg/ArrowLeft"

import SignInForm from "./SignInForm";
import SignUpForm from "./SignUpForm";

interface AuthDialogProps {
  sendCalculatorData?: boolean;
  isSignInOnly?: boolean;
  handleClose?(): void;
  successCallback(resultResponse: CalculatorResult): void;
  haveBackArrow?: boolean
}

function AuthDialog({
  sendCalculatorData = true,
  isSignInOnly,
  handleClose,
  successCallback,
  haveBackArrow
}: AuthDialogProps) {
  const [isLogin, setIsLogin] = useState<boolean>(Boolean(isSignInOnly));
  const [haveArrow, setHaveArrow] = useState<boolean>(Boolean(haveBackArrow));

  useEffect(() => {
    console.log('havearrow: ', haveArrow)
  }, [haveArrow])
  return (
    <Container>
      <Dialog>
        {Boolean(handleClose) && (
          <CloseActionContainer onClick={handleClose}>
            <CloseButton>
              <CrossIcon />
            </CloseButton>
          </CloseActionContainer>
        )}
        {isLogin && haveArrow ? (
          <div onClick={() => setIsLogin(false)}>
            <a>
              <ArrowLeft />
            </a>
          </div>
        ) : (<></>)}
        <Title>¡Mejora tu huella de carbono con Digien!</Title>
        {isLogin ? (
          <SignInForm
            successCallback={successCallback}
            sendCalculatorData={sendCalculatorData}
          />
        ) : (
          <SignUpForm
            successCallback={successCallback}
            switchToSignIn={() => setIsLogin(true)}
          />
        )}
      </Dialog>
    </Container>
  );
}

export default AuthDialog;
